import React from "react";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

export const SuprLoc = ({
  setSuprLoc,
  idSelected,
  stockageALibrerer,
  onClose,
}) => {
  const toast = React.useRef(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleConfirm = () => {
    try {
      axios
        .post(`${apiUrl}IHM/api/location.php?idSupr=${idSelected}`)
        .then((response) => {
          libererStockage();
          toast.current.show({
            severity: 'success',
            summary: 'Succès',
            detail: `Location n° ${idSelected} supprimée avec succès`,
            life: 3000
          });
          setTimeout(() => {
            setSuprLoc(false);
            if (typeof onClose === "function") onClose();
            window.location.reload();
          }, 1500);
        })
        .catch((error) => {
          console.error("Erreur:", error);
          toast.current.show({
            severity: 'error',
            summary: 'Erreur',
            detail: 'Erreur lors de la suppression',
            life: 3000
          });
        });
    } catch (error) {
      console.error("Erreur:", error);
      toast.current.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors de la suppression',
        life: 3000
      });
    }
  };

  const libererStockage = () => {
    try {
      if (stockageALibrerer) {
        axios
          .post(`${apiUrl}IHM/api/stockage.php?idSliberer=${stockageALibrerer}`)
          .then((response) => {
            console.log("Stockage libéré:", response);
          })
          .catch((error) => {
            console.error("Erreur lors de la libération du stockage:", error);
          });
      }
    } catch (error) {
      console.error("Erreur:", error);
    }
  };

  const handleCancel = () => {
    toast.current.show({
      severity: 'info',
      summary: 'Annulé',
      detail: `Suppression de la location n° ${idSelected} annulée`,
      life: 3000
    });
    setTimeout(() => {
      setSuprLoc(false);
      if (typeof onClose === "function") onClose();
    }, 1000);
  };

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg" style={{ color: "#dc2626" }}>
        <i className="pi pi-trash" style={{ marginRight: "8px" }} />
        Supprimer la location
      </span>
      <Button
        icon="pi pi-times"
        rounded
        text
        size="small"
        style={{ color: "#6b7280" }}
        onClick={() => {
          setSuprLoc(false);
          if (typeof onClose === "function") onClose();
        }}
      />
    </div>
  );

  return (
    <>
      <Toast ref={toast} />

      <Dialog
        blockScroll
        visible={true}
        header={header}
        className="custom-dialog"
        style={{ width: "40vw", maxWidth: "500px" }}
        modal
        onHide={() => {
          setSuprLoc(false);
          if (typeof onClose === "function") onClose();
        }}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="p-3">
          <div className="grid">
            <div className="col-12">
              <div
                style={{
                  background: "#fef2f2",
                  padding: "12px 16px",
                  borderRadius: "6px",
                  marginBottom: "20px",
                  border: "1px solid #fecaca",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <span
                  style={{
                    background: "#dc2626",
                    color: "white",
                    borderRadius: "50%",
                    width: "28px",
                    height: "28px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: 700,
                  }}
                >
                  !
                </span>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#991b1b",
                  }}
                >
                  CONFIRMATION DE SUPPRESSION
                </span>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12">
              <p style={{ fontSize: "15px", color: "#374151", textAlign: "center", marginBottom: "10px" }}>
                Voulez-vous vraiment supprimer la location <strong>n° {idSelected}</strong> ?
              </p>
              {stockageALibrerer && (
                <p style={{ fontSize: "13px", color: "#6b7280", textAlign: "center", marginBottom: "10px" }}>
                  Le stockage <strong>{stockageALibrerer}</strong> sera libéré.
                </p>
              )}
              <p style={{ fontSize: "13px", color: "#6b7280", textAlign: "center", marginBottom: "30px" }}>
                Cette action est irréversible.
              </p>
            </div>
          </div>

          <div className="grid">
            <div className="col-12">
              <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                <Button
                  label="Annuler"
                  icon="pi pi-times"
                  className="p-button-text"
                  style={{
                    padding: "10px 30px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#6b7280",
                    border: "1px solid #d1d5db",
                    background: "white",
                  }}
                  onClick={handleCancel}
                />
                <Button
                  label="Supprimer"
                  icon="pi pi-trash"
                  style={{
                    background: "#dc2626",
                    border: "none",
                    padding: "10px 30px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "white",
                  }}
                  onClick={handleConfirm}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};